import joi from 'joi';
import {
  $updateTotals,
  RuleI18nAttributes,
  UpdateTotals,
  ruleI18nAttributesSchema,
} from '../rule-api-client';
import { EventProfile } from '../ingestor-types';
import {
  ProfileRewardAttributes,
  TransactionAttributes,
  TransactionI18nAttributes,
  transactionI18nAttributesSchema,
} from '../profile-api-client';

export interface BurnRuleResult {
  transactions: TransactionAttributes[];
  reward: ProfileRewardAttributes;
}

export interface BurnEvent {
  id: string;
  payload: {
    programId: string;
  };
}

export interface AdjustBalancePayload {
  currencyId: string;
  amount: number;
  i18nAttributes: TransactionI18nAttributes;
  updateTotals?: UpdateTotals;
}

export const adjustBalancePayloadSchema = joi.object<AdjustBalancePayload>({
  currencyId: joi.string(),
  amount: joi.number(),
  i18nAttributes: transactionI18nAttributesSchema,
  updateTotals: $updateTotals,
});

export interface OfferRewardPayload {
  rewardId: string;
  i18nAttributes: RuleI18nAttributes;
}

export const offerRewardPayloadSchema = joi.object<OfferRewardPayload>({
  rewardId: joi.string(),
  i18nAttributes: ruleI18nAttributesSchema,
});

export enum EventReportStatus {
  success = 'success',
  error = 'error',
  orphan = 'orphan',
  orphanReprocessing = 'orphanReprocessing',
  orphanReprocessed = 'orphanReprocessed',
  denied = 'denied',
}

export interface EventReportAttributes {
  id: number;
  result: Record<string, any>; // TODO type this using RulesExecutionAnalytics
  createdAt: Date;
  updatedAt: Date;
  eventTimestamp: Date;
  eventCreatedAt: Date;
  accountId?: string;
  programId?: string;
  profile?: EventProfile;
  profileId?: string;
  eventId: string;
  clientEventId?: string;
  status: string;
  eventSource?: string;
  eventName?: string;
  isTestUser?: boolean;
  isRepublished?: boolean;
}
